<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Mail Configuration</template>
    <template v-slot:body class="text-center">
      <v-progress-circular v-if="loading" indeterminate size="64" color="primary" />
          <v-row v-else>
            <v-col cols="12">
              <h3>
                Email Configuration Details
              </h3>
              <p class="mt-3">
                <b>Username</b>: {{ accountData.account }}
              </p>
              <p>
                <b>Password</b>: <i>Use the email account’s password.</i>
              </p>
              <p class="mb-0">
                <b>Incoming Server</b>: {{ accountData.inbox_host }}
              </p>
              <p class="mb-3">
                <b>{{ accountData.inbox_service.toUpperCase() }} Port</b>: {{ accountData.inbox_port }}
              </p>
              <p class="mb-0">
                <b>Outgoing Server</b>: {{ accountData.smtp_host }}
              </p>
              <p class="mb-3">
                <b>SMTP Port</b>: {{ accountData.smtp_port }}
              </p>
              <p>
                IMAP, POP3, and SMTP require authentication.
              </p>
              <hr>
              <h3>
              Send Configuration Detail Via Email
              </h3>
              <p class="mt-3">
                Send configuration information for “{{ accountData.account }}” to the following email address:
              </p>
              <v-form>
                <v-text-field outlined
                              v-model="settingsEmail"
                              label="Email"
                              name="Email"
                              v-validate="'required|email'"
                              :error-messages="errors.collect('Email')"></v-text-field>
                <gg-btn tile
                        color="primary"

                        @click="sendInstructions"
                        :loading="sendingInstructions">Send Instructions</gg-btn>
              </v-form>
            </v-col>
          </v-row>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ConfigurationModal',
  mixins: [modalMixin],
  props: {
    account: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      loading: true,
      panels: 0,
      accountData: null,
      settingsEmail: '',
      sendingInstructions: false,
    }
  },
  methods: {
    ...mapActions(['cpanel_uapi', 'reportError', 'reportSuccess']),
    async getConfiguration () {
      this.loading = true
      let response
      const data = {
        uapi_module: 'Email',
        uapi_function: 'get_client_settings',
        account: this.account,
        _username: this.$route.query.user,
      }
      try {
        response = await this.cpanel_uapi(data)
        this.accountData = response.payload?.data
      } catch (e) {
        this.reportError(e)
        this.close()
        return
      }
      this.loading = false
    },
    async sendInstructions () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.sendingInstructions = true
      const data = {
        uapi_module: 'Email',
        uapi_function: 'dispatch_client_settings',
        to: this.settingsEmail,
        account: this.accountData.account,
        _username: this.$route.query.user,
      }
      try {
        await this.cpanel_uapi(data)
        this.settingsEmail = ''
      } catch (e) {
        this.reportError(e)
      }
      this.reportSuccess('Settings successfully sent.')
      this.sendingInstructions = false
    },
  },
  watch: {
    dialog (newVal) {
      if (newVal) {
        this.getConfiguration()
      } else {
        this.loading = true
      }
    }
  }
}
</script>
